export type FileTransferPolicyErrorCode =
  | "invalid-size"
  | "file-too-large"
  | "comparison-too-large"
  | "zip-too-large"
  | "zip-too-many-files"
  | "content-length-mismatch";

export class FileTransferPolicyError extends Error {
  constructor(
    public readonly code: FileTransferPolicyErrorCode,
    message: string,
  ) {
    super(message);
    this.name = "FileTransferPolicyError";
  }
}

export interface FileTransferConfig {
  readonly uploadConcurrency: number;
  readonly contentConcurrency: number;
  readonly previewMaxBytes: number;
  readonly diffMaxBytes: number;
  readonly downloadMaxBytes: number;
  readonly zipMaxBytes: number;
  readonly zipMaxFiles: number;
}

export interface FileTransferMetadata {
  readonly name: string;
  readonly size: number;
}
